var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconExpand2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0542 7.82251C13.0522 8.17139 12.9782 8.5159 12.8371 8.83349C12.6892 9.17697 12.4477 9.46961 12.1416 9.67646C11.8355 9.88331 11.4777 9.99563 11.1109 10H1.96994C1.60315 9.99563 1.24535 9.88331 0.939261 9.67646C0.633171 9.46961 0.391734 9.17697 0.243785 8.83349C0.0613632 8.43827 -0.00889789 7.99856 0.0410074 7.56447C0.0909126 7.13037 0.258977 6.71935 0.526049 6.37825L5.09655 0.712329C5.26941 0.490142 5.489 0.310708 5.73898 0.187379C5.98897 0.0640497 6.26292 0 6.54044 0C6.81797 0 7.09191 0.0640497 7.3419 0.187379C7.59189 0.310708 7.81148 0.490142 7.98433 0.712329L12.5548 6.37825C12.8785 6.78667 13.0548 7.29668 13.0542 7.82251Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand2);
export default __webpack_public_path__ + "static/media/iconExpand2.9bbb6ee8e55e3fd00a9325af4036418f.svg";
export { ForwardRef as ReactComponent };